import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], total:0 ,  error: "", message: "" }


export const userAttemptedChallengeAction = createAsyncThunk(
    'user-attempted-challenge',
    async (data = null, { rejectWithValue }) => {
        try {
            // const res = await axios.get(`/admins/api/userChallengeAttempted?challenge_id=${data?.challenge_id}&user_id=${data?.user_id}`)
            const res = await axios.get(`/admins/api/userChallengeAttempted?challenge_history_id=${data?.challenge_history_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const userAttemptedChallengeSlice = createSlice({
    name: 'user-attempted-challenge',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(userAttemptedChallengeAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(userAttemptedChallengeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.count
            })
            builder.addCase(userAttemptedChallengeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const userAttemptedChallengeReducer = userAttemptedChallengeSlice.reducer    